// 수신자료관리 - ERP_모듈정보조회
import { Route, Switch } from 'react-router-dom';
import { lazy, Suspense } from 'react';


const RNTC8  = lazy(() => import('@/pages/B06/RNTC8'));   // 모듈단가 조회
const RNTC9  = lazy(() => import('@/pages/B06/RNTC9'));   // 모듈단가 상세내역
const RNTC10 = lazy(() => import('@/pages/B06/RNTC10'));  // 모듈별 정산현황
const RNTC11 = lazy(() => import('@/pages/B06/RNTC11'));  // 사양차이 정산 상세내역
const RNTC12 = lazy(() => import('@/pages/B06/RNTC12'));  // 단가차이 정산 상세내역
const RNTC13 = lazy(() => import('@/pages/B06/RNTC13'));  // ZERO 단가 조건 정산 상세내역
const RNTC14 = lazy(() => import('@/pages/B06/RNTC14'));  // 정단가 조건 정산 상세내역

function B06() {
  return ( 
    <Suspense fallback={null}>
      <Switch>
        <Route path="/B06/RNTC8" component={RNTC8} />
        <Route path="/B06/RNTC9" component={RNTC9} />
        <Route path="/B06/RNTC10" component={RNTC10} />
        <Route path="/B06/RNTC11" component={RNTC11} />
        <Route path="/B06/RNTC12" component={RNTC12} />
        <Route path="/B06/RNTC13" component={RNTC13} />
        <Route path="/B06/RNTC14" component={RNTC14} />
      </Switch>
    </Suspense>
  );
}

export default B06;
